<template>
  <div class="block-title flex flex-align-center">
    <p
      v-if="emoji"
      class="emoji">{{ emoji }}</p>
    <p class="title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'BlockTitle',
  props: {
    title: {
      type: String,
      required: true,
    },
    emoji: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.block-title {
  margin-top: 13px;
  margin-bottom: 10px;

  .emoji {
    font-size: 10px;
    margin-right: 5px;
  }

  .title {
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    color: $blackLight;
  }
}
</style>
